import { useTranslation } from 'react-i18next';

import {
  ZfDialog,
  ZfDialogContent,
  ZfDialogFooter,
  ZfDialogHeader,
  ZfLoadingSpinner,
  ZfStack,
  ZfTextButton,
  ZfTypography,
} from '@zafire/react';

type SubmissionDialogType = {
  showDialog: boolean;
  onDialogClose: () => void;
  onProceed: () => void;
  loading: boolean;
};
const SubmissionDialog = ({ showDialog, onDialogClose, onProceed, loading }: SubmissionDialogType) => {
  const { t } = useTranslation();
  return (
    <ZfDialog show={showDialog} size="small" onDialogClose={onDialogClose} disableClose>
      <ZfDialogHeader>{t('contactNote.form.submission.title')}</ZfDialogHeader>
      <ZfDialogContent>
        <ZfTypography>{t('contactNote.form.submission.detail')}</ZfTypography>
        <ZfTypography style={{ textWrap: 'wrap' }}>{t('contactNote.form.submission.subDetail')}</ZfTypography>
      </ZfDialogContent>
      <ZfDialogFooter>
        <ZfStack slot="primary" direction="row" spacing="small">
          <ZfTextButton size="medium" hierarchy="tertiary" onClick={onDialogClose}>
            {t('contactNote.form.submission.cancel')}
          </ZfTextButton>
          <ZfTextButton
            size="medium"
            onClick={() => {
              loading ? null : onProceed();
            }}
          >
            {loading && <ZfLoadingSpinner color="light" size="small" />}
            {t('contactNote.form.submission.submit')}
          </ZfTextButton>
        </ZfStack>
      </ZfDialogFooter>
    </ZfDialog>
  );
};

export default SubmissionDialog;
